module.exports = __webpack_public_path__ + "static/img/underhill-jack.4cfa5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/underhill-jack.jpg
// module id = m6oF
// module chunks = 0